import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "customerSupportComponent text-center pt-4 pb-3 px-2" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h3", { class: "h4 mb-2" }, "Customer Support", -1);
const _hoisted_3 = {
    key: 0,
    class: "font8-responsive"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block pointerhover text-underline" }, "support@myswooop.de", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-4" }, "Benötigst du unsere Unterstützung?", -1);
const _hoisted_6 = { style: { "display": "flex", "justify-content": "space-evenly", "align-items": "center" } };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/_new_brand/customer_service_michelle_100x100.jpg",
    width: "100",
    height: "100",
    alt: "Customer Service",
    class: "mr-2 ml-md-3"
}, null, -1);
const _hoisted_8 = { class: "text-left mb-0 font6-responsive" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_email" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", { class: "pointerhover text-underline" }, "support@­myswooop.de", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_clock" }, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block" }, "Mo-Fr 09:00 -", -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_email" }, null, -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("span", { class: "pointerhover text-underline" }, "support@­myswooop.de", -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_phone" }, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("a", {
    href: "tel:+49 (0) 421 98 96 87 0",
    title: "mySWOOOP Telefonnummer",
    class: "text-white"
}, " +49 (0)421­ 98 96 87 0 ", -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_clock" }, null, -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block" }, "Mo-Fr 09:00 -", -1);
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerSupportInfo',
    setup(__props) {
        const supportDelay = ref(true);
        return (_ctx, _cache) => {
            const _component_open_popup_button = _resolveComponent("open-popup-button");
            return (_openBlock(), _createElementBlock("article", _hoisted_1, [
                _hoisted_2,
                (supportDelay.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                        _createTextVNode(" Aktuell kommt es zu einem stark erhöhtem Anrufaufkommen und damit zu längerer Wartezeit. Schreibe uns daher am besten eine E-Mail an "),
                        _createVNode(_component_open_popup_button, { "popup-name": "openContactPopup" }, {
                            default: _withCtx(() => [
                                _hoisted_4
                            ]),
                            _: 1
                        }),
                        _createTextVNode(" - wir melden uns schnellstmöglich bei dir zurück! ")
                    ]))
                    : _createCommentVNode("", true),
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, [
                        (supportDelay.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Schreib Michelle: "),
                                _hoisted_9,
                                _hoisted_10,
                                _createVNode(_component_open_popup_button, { "popup-name": "openContactPopup" }, {
                                    default: _withCtx(() => [
                                        _hoisted_11
                                    ]),
                                    _: 1
                                }),
                                _hoisted_12,
                                _hoisted_13,
                                _hoisted_14,
                                _createTextVNode(" 17:00 ")
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" Sprich mit Michelle: "),
                                _hoisted_15,
                                _hoisted_16,
                                _createVNode(_component_open_popup_button, { "popup-name": "openContactPopup" }, {
                                    default: _withCtx(() => [
                                        _hoisted_17
                                    ]),
                                    _: 1
                                }),
                                _hoisted_18,
                                _hoisted_19,
                                _hoisted_20,
                                _hoisted_21,
                                _hoisted_22,
                                _hoisted_23,
                                _createTextVNode(" 17:00 ")
                            ], 64))
                    ])
                ])
            ]));
        };
    }
});
